import { RESTproxy } from '../RESTproxy';
import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

const applicationJsonHeader = { 'Content-Type': 'application/json' };

export class CatalogProxy extends RESTproxy {
    constructor() {
        super('catalog');
    }

    async uploadFiles(id, files, fileToVariantMap) {
        const formData = new FormData();
        files.forEach(file => formData.append(file.uuid, file));
        formData.append('fileToVariantMap', JSON.stringify(fileToVariantMap));

        const response = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/catalog/upload/${id}`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const message = await response.text();
            throw new Error(message || response.statusText || 'Upload failed');
        }

        const contentType = response.headers.get('Content-Type') || '';
        if (contentType.includes('application/json')) {
            return response.json();
        }
        return {};
    }

    async search(query) {
        const response = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/catalog/items/query`, {
            method: 'POST',
            headers: applicationJsonHeader,
            body: JSON.stringify(query),
        });

        if (!response.ok) {
            throw new Error('can not search the catalog');
        }

        return response.json();
    }

    async query(ids) {
        if (ids.length === 0) {
            return [];
        }

        const response = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/catalog/query`, {
            method: 'POST',
            headers: applicationJsonHeader,
            body: JSON.stringify(ids),
        });

        if (!response.ok) {
            throw new Error('can not fetch catalog items');
        }

        return response.json();
    }
}
